import axios from 'axios';
import * as CryptoJS from 'crypto-js';

const baseURL = `${process.env.REACT_APP_API_URL}/accounts/index.php`;
let CryptoJSAesJson = {
    /**
     * Encrypt any value
     * @param {*} value
     * @param {string} password
     * @return {string}
     */
    'encrypt': function (value, password) {
        return CryptoJS.AES.encrypt(JSON.stringify(value), password, { format: CryptoJSAesJson }).toString()
    },
    /**
     * Decrypt a previously encrypted value
     * @param {string} jsonStr
     * @param {string} password
     * @return {*}
     */
    'decrypt': function (jsonStr, password) {
        return JSON.parse(CryptoJS.AES.decrypt(jsonStr, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8))
    },
    /**
     * Stringify cryptojs data
     * @param {Object} cipherParams
     * @return {string}
     */
    'stringify': function (cipherParams) {
        var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) }
        if (cipherParams.iv) j.iv = cipherParams.iv.toString()
        if (cipherParams.salt) j.s = cipherParams.salt.toString()
        return JSON.stringify(j).replace(/\s/g, '')
    },
    /**
     * Parse cryptojs data
     * @param {string} jsonStr
     * @return {*}
     */
    'parse': function (jsonStr) {
        var j = JSON.parse(jsonStr)
        var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams
    }
}

export const accountService = {
    getUser,
    registerMarathon,
    registerRunner,
    getRegistration,
    getAllRegistration,
    checkRegistration,
    registerGroupRunner,
    checkPromo,
    updateRegistration,
    getUpdatePayment,
    getShirtCap,
    remakePayment,
    getPaymentByID,
    getGroupRegistration
};

async function getUser(userID){
    // let valueToEncrypt = userID;
    // console.log(userID);

    var valueToEncrypt = {
        userID : userID,
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    return await axios.post(`${baseURL}?type=5`, encrypted)
        .then(response => response.data)
        .catch(err => {console.log(err)});
}

async function registerMarathon(userID, values, promo, paymentID, platform)
{
    let valueToEncrypt = {
        userID : userID,
        data : values,
        promo : promo,
        paymentID : paymentID,
        platform : platform
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=6`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function registerRunner(userID, runners, promo, paymentID, platform)
{
    let valueToEncrypt = {
        userID : userID,
        runners : runners,
        promo : promo,
        paymentID : paymentID,
        platform : platform
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=27`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function getRegistration(userID, token, marathonName)
{
    let valueToEncrypt = {
        userID : userID,
        token : token,
        marathonName : marathonName
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=12`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function getAllRegistration(userID, token) {
    let valueToEncrypt = {
        userID : userID,
        token : token
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=14`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function checkRegistration(values){
    let valueToEncrypt = {
        runner : values,
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=26`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function registerGroupRunner(values, promo) {
    let valueToEncrypt = {
        runners : values,
        promo : promo
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=31`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function checkPromo(promoCode) {
    let valueToEncrypt = {
        promoCode : promoCode
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // check the existence of the runner
    return await axios.post(`${baseURL}?type=18`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}

async function updateRegistration(userData, userID) {
    var valueToEncrypt = {
        userID : userID,
        userData : userData
    };

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    return await axios.post(`${baseURL}?type=19`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err)});
}

async function getUpdatePayment(upaymentID){
    var valueToEncrypt = {
        upaymentID : upaymentID,
    };

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // console.log(encrypted);

    return await axios.post(`${baseURL}?type=20`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err)});
}

async function getShirtCap(){
    try {
        return await axios.get(`${baseURL}?type=4`)
            .then(response => response.data)
            .catch(err => console.error(err));
    } catch (err) {
        console.error(err);
        return err;
    }
}

async function remakePayment(paymentID) {
    var valueToEncrypt = {
        paymentID : paymentID
    };

    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    var encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    return await axios.post(`${baseURL}?type=25`, encrypted)
                    .then(response => response.data)
                    .catch(err => {console.log(err)});
}

async function getPaymentByID(paymentID) {
    try {
        return await axios.get(`${baseURL}?type=2&paymentID=${paymentID}`)
            .then(response => response.data)
            .catch(err => console.error(err));
    } catch (err) {
        console.error(err);
        return err;
    }
}

async function getGroupRegistration(groupCode) {
    let valueToEncrypt = {
        groupCode : groupCode
    };
    let password = process.env.REACT_APP_ENCRYPT_PRIVATE_KEY;
    let encrypted = CryptoJSAesJson.encrypt(valueToEncrypt, password);

    // get the registration detail by group code
    return await axios.post(`${baseURL}?type=32`, encrypted)
                .then(response => response.data)
                .catch(err => {console.log(err.response)});
}